import React, { useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Input, Card, Button, Modal, List, Typography } from "antd";
import LockIcon from "../../assets/images/lock-icon.svg";
const { TextArea } = Input;

const { Title, Paragraph } = Typography;

export default function JournalAIChat() {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="notebook-chat">
        <div className="notebook-chat-wrapper">
          <Card className="ai-chat-card">
            <div className="list-wrapper">
              <List
                className="notebook-chat-list"
                itemLayout="vertical"
                size="large"
              >
                <List.Item>
                  <div className="original-chat">
                    <TextArea
                      value="Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,"
                      className="note-book"
                    />
                    <div className="d-flex justify-content-end">
                      <Button danger type="primary">
                        Use Original
                      </Button>
                    </div>
                  </div>
                </List.Item>
                <List.Item>
                  <div className="resolve-chat">
                    <TextArea
                      value="Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,"
                      className="note-book"
                    />
                    <div className="btn-wrap d-flex justify-content-start">
                      <Button className="resolve-ai-btn" type="primary">
                        Use RESOLVEit Text
                      </Button>
                      <Button
                        ghost
                        icon={<i className=" icon-edit-message"></i>}
                        type="primary"
                      >
                        Edit
                      </Button>
                    </div>
                  </div>
                </List.Item>
              </List>
            </div>
          </Card>
          <div className="notebook-chat-footer">
            <Button
              className="lock-btn"
              icon={<i className="icon-lock-circle"></i>}
              size="large"
              type="primary"
            >
              45: 23
            </Button>
            <Button size="large" ghost onClick={showModal}>
              Cancel
            </Button>
          </div>
        </div>
        <Modal
          centered
          mask={false}
          open={open}
          onOk={handleOk}
          onCancel={handleCancel}
          closable={false}
          className="post-confirmation-modal"
          okText="Yes, Post"
          cancelText="No, Edit"
          cancelButtonProps={{
            ghost: true,
          }}
        >
          <InfoCircleOutlined />
          <Title level={4}>Confirmation</Title>
          <Paragraph className="text">
            This will be posted to the Journal and neither you nor your
            co-Journalist will be able to create a new entry for 1 hour. This is
            designed to allow both parties to digest what has been said and
            respond accordingly.
          </Paragraph>
          <Paragraph className="text">
            Are you ready to post this journal entry?
          </Paragraph>
        </Modal>
      </div>
    </>
  );
}
